import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ApprovalActionsPanel = ({
  selectedUser,
  onApprove,
  onReject,
  getRoleLabel
}) => {
  if (!selectedUser) {
    return (
      <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-6">
        <div className="text-center py-8">
          <Icon name="UserCircle" size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground text-sm">اختر مستخدم من القائمة</p>
          <p className="text-xs text-muted-foreground mt-2">لعرض التفاصيل وإجراءات الموافقة</p>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleDateString('ar-SA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="bg-card/50 backdrop-blur-sm border border-border rounded-lg p-4 space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="UserCircle" size={20} color="#3B82F6" />
        <h3 className="font-semibold text-white">معاينة الملف</h3>
      </div>

      {/* User Avatar */}
      <div className="flex justify-center mb-4">
        <div className="p-6 bg-primary/20 rounded-full">
          <Icon name="User" size={48} color="#3B82F6" />
        </div>
      </div>

      {/* User Info */}
      <div className="space-y-3">
        <div className="text-center pb-3 border-b border-border">
          <h4 className="font-bold text-white text-lg">{selectedUser?.full_name}</h4>
          <p className="text-sm text-muted-foreground mt-1">{selectedUser?.email}</p>
        </div>

        <div className="space-y-2">
          <div className="flex items-start gap-2">
            <Icon name="Briefcase" size={16} className="text-primary mt-1" />
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">الدور</p>
              <p className="text-sm font-medium text-white">{getRoleLabel(selectedUser?.role)}</p>
            </div>
          </div>

          <div className="flex items-start gap-2">
            <Icon name="Phone" size={16} className="text-green-400 mt-1" />
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">الهاتف</p>
              <p className="text-sm font-medium text-white">{selectedUser?.phone || 'غير متوفر'}</p>
            </div>
          </div>

          <div className="flex items-start gap-2">
            <Icon name="Calendar" size={16} className="text-yellow-400 mt-1" />
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">تاريخ التسجيل</p>
              <p className="text-sm font-medium text-white">{formatDate(selectedUser?.created_at)}</p>
            </div>
          </div>

          <div className="flex items-start gap-2">
            <Icon name="Shield" size={16} className="text-purple-400 mt-1" />
            <div className="flex-1">
              <p className="text-xs text-muted-foreground">الحالة</p>
              <p className="text-sm font-medium text-white">
                {selectedUser?.approval_status === 'pending_approval' && 'قيد المراجعة'}
                {selectedUser?.approval_status === 'approved' && 'موافق عليه'}
                {selectedUser?.approval_status === 'rejected' && 'مرفوض'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      {selectedUser?.approval_status === 'pending_approval' && (
        <div className="space-y-2 pt-4 border-t border-border">
          <p className="text-xs font-medium text-muted-foreground mb-3">إجراءات سريعة</p>
          <Button
            onClick={() => onApprove(selectedUser?.id)}
            variant="default"
            iconName="CheckCircle"
            className="w-full"
          >
            موافقة فورية
          </Button>
          <Button
            onClick={() => onReject(selectedUser)}
            variant="destructive"
            iconName="XCircle"
            className="w-full"
          >
            رفض الطلب
          </Button>
        </div>
      )}

      {/* Approval Info */}
      {selectedUser?.approval_status === 'approved' && (
        <div className="p-3 bg-green-500/10 border border-green-500/30 rounded-lg">
          <div className="flex items-center gap-2 text-sm text-green-400">
            <Icon name="CheckCircle" size={16} />
            <span className="font-medium">تمت الموافقة</span>
          </div>
          {selectedUser?.approved_at && (
            <p className="text-xs text-green-300 mt-1">
              {formatDate(selectedUser?.approved_at)}
            </p>
          )}
        </div>
      )}

      {selectedUser?.approval_status === 'rejected' && (
        <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="XCircle" size={16} className="text-red-400 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-red-400 mb-1">مرفوض</p>
              {selectedUser?.rejection_reason && (
                <p className="text-xs text-red-300">{selectedUser?.rejection_reason}</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApprovalActionsPanel;